/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react";
import { Route, useHistory, useLocation, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  getLoginDataAction,
  isCompanyDegraded,
  refreshDegradedCompanyAction,
} from "../../redux/userDuck";
import { getLabelMessage } from "../../const/labelService";
import Nav from "./Nav/Nav";
import Loader from "../loader/Loader";
import routeGuard from "../../router/routeGuard";
import { toast } from "react-toastify";

import {
  GridLayout,
  Main,
  SectionPage,
  Title,
  PageContainer,
} from "./DashboardLayout.style";
import { clearDataAction } from "../../redux/locationsDuck";
import CONSTANTS from "../../const/constants";
import {
  archivedBroadConversationAction,
  archivedConversationAction,
  deleteConversationAction,
  getClientNameFromNotification,
  markAsConversationValuable,
  markAsReadAction,
  markAsUnReadAction,
  unassignClient,
  updateClientTags,
  updateConverations,
  updateMessageStatus,
  finishBotAssignment,
  setConversationClosed,
  handleGroupAdmin,
  handleConversationVisibilityChanged,
} from "../../redux/conversationsDuck";
import useBinder from "../../hooks/useBinder";
import { useChatRealtimeRecovery } from "../../hooks/useChatRealtimeRecovery";
import { useSessionGuard, shouldClearSession } from "../../hooks/useSessionGuard";
import { endSessionUnlessSede } from "../../utils/partnerAccess/sedeSession";
import { isSedeMode } from "../../utils/partnerAccess/partnerStorage";
import useSedeLostNotice from "../../hooks/useSedeLostNotice";
import SuscriptionAlert from "./SuscriptionAlert/SuscriptionAlert.component";
import IncidentBanner from "./IncidentBanner/IncidentBanner.component";
import PlanStatus from "../../const/planStatus";
import { updateDatasheet } from "../../redux/dataSheetConfigurationDuck";
import {
  conversationSeatedReceived,
  conversationUnseatedReceived,
  capacityReceived,
  queueChangedReceived,
  agentLoadReceived,
} from "../../redux/conversationLimitRealtime";
import { useCallback } from "react";
import { canSeeInicio, INICIO_ROUTE, receivesHumanTasks } from "../../views/dashboard/inicio/access";
import { HUMAN_TASK_EVENTS } from "../../views/dashboard/inicio/constants/realtime-events";
import { humanTaskNotificationActions } from "../../views/dashboard/inicio/realtime/human-tasks-realtime";

const DashboardLayout = ({ component: Component, validateAuth, ...props }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const channels = useSelector((state) => state.channels);
  const user = useSelector((state) => state.user);
  const isPaymentLocation = location.pathname.includes(CONSTANTS.UPDATE_SUBSCRIPTION_ROUTE);
  const whatsappTemplateView = useSelector(
    (state) => state.whatsappTemplates.whatsappTemplateView
  );
  const isWhatsappTemplateWithVars = useSelector(
    (state) => state.whatsappTemplates.createTemplate.isVariables
  );

  const [viewTitle, setViewTitle] = useState();

  const labels = [
    "configurationViewTitle",
    "SpacesViewTitle",
    "UsersViewTitle",
    "QuickAnswersViewTitle",
    "MultimediaViewTitle",
    "whatsappTemplatesRouteLabel",
    "newWhatsappTempateRouteLabel",
    "createWhatsappTemplate",
    "BotTitle",
    "BroadcastTitle",
    "newWhatsappTemplate",
    "newCustomWhatsappTemplate",
    "whatsappTemplateCategoryView",
    "customWhatsappTemplateTitle",
    "whatsappTemplateTitle",
    "customWhatsappTemplateTitle",
  ];
  const lbls = getLabelMessage(labels);
  let isChat = false;

  const handleNotification = useCallback((data, eventName) => {
    console.log("Binder:: Notification received");

    let cleanedData = data;
    if (data?.client?.id) {
      cleanedData = cleanCircularObjects(data);
    }

    // Modo cola events carry no `type`; useBinder passes their event name.
    const actionType = cleanedData?.type || eventName;
    const actionToDispatch = notificationActions[actionType];
    console.log("Binder:: action to dispatch: ", actionType);

    const currentPath = history.location.pathname;

    if (actionToDispatch) {
      if (
        currentPath.includes("/chat") ||
        currentPath.includes("/board") ||
        actionType === "onLinkedChannel" ||
        actionType === "updateUserData" ||
        // Inicio: the task toast reaches the agent on any screen (S11).
        HUMAN_TASK_EVENTS.includes(actionType)
      ) {
        dispatch(actionToDispatch(cleanedData));
      }
    }
  }, [history, dispatch])

  const binder = useBinder(user, (data, eventName) => handleNotification(data, eventName));

  // Pusher se reconecta solo, pero los eventos de la caída se pierden. Sin esto
  // el asesor se queda con la bandeja congelada hasta que recarga a mano
  // (DASHBOARD-ZC-KT). El tablero ya lo hacía; el chat no.
  useChatRealtimeRecovery();
  useSedeLostNotice();

  const { path } = props;

  if (location.pathname.includes("/chat")) isChat = true;

  useEffect(() => {
    switch (whatsappTemplateView) {
      case "initWhatsappTemplateView":
        // setViewTitle(lbls.initWhatsappTemplateView);
        setViewTitle(lbls.configurationViewTitle);
        break;
      case "createWhatsappTemplate":
        setViewTitle(lbls.createWhatsappTemplate);
        break;
      case "newWhatsappTemplate":
        setViewTitle(lbls.newWhatsappTemplate);
        break;
      case "newCustomWhatsappTemplate":
      case "identifyVariables":
        setViewTitle(lbls.newCustomWhatsappTemplate);
        break;
      case "whatsappTemplateCategory":
        setViewTitle(lbls.whatsappTemplateCategoryView);
        break;
      case "addMultimedia":
      case "previewMessage":
        if (isWhatsappTemplateWithVars) {
          setViewTitle(lbls.customWhatsappTemplateTitle);
        } else {
          setViewTitle(lbls.whatsappTemplateTitle);
        }
        break;
      case "creditsView":
        setViewTitle(lbls.creditsView);
        break;

      case "broadcastForLabelView":
        setViewTitle(lbls.broadcastForLabelView);
        break;

      default:
        break;
    }
  }, [whatsappTemplateView]);

  useEffect(() => {
    switch (location.pathname) {
      case "/config":
      case "/config/new-tag":
      case "/config/new-rol":
      case "/config/new-datasheet":
      case "/config/edit-card":
      case "/config/edit-plan":
      case "/chat":
        setViewTitle(lbls.configurationViewTitle);
        break;
      case "/config/new-whatsapp-template":
        break;
      case "/spaces":
      case "/spaces/new":
      case "/spaces/new-whatsapp":
        setViewTitle(lbls.SpacesViewTitle);
        break;
      case "/users":
      case "/users/new":
        setViewTitle(lbls.UsersViewTitle);
        break;
      case "/bot":
        setViewTitle(lbls.BotTitle);
        break;
      case "/broadcast":
        setViewTitle(lbls.BroadcastTitle);
        break;
      case CONSTANTS.QUICK_ANSWERS_ROUTE:
      case CONSTANTS.QUICK_ANSWERS_ACTION_ROUTE:
        setViewTitle(lbls.QuickAnswersViewTitle);
        break;
      case CONSTANTS.MULTIMEDIA_ROUTE:
      case CONSTANTS.ALBUM_ROUTE:
      case CONSTANTS.SUBALBUM_ROUTE:
        setViewTitle(lbls.MultimediaViewTitle);
        break;
      case "/account":
        setViewTitle("Mi cuenta");
        break;
      case "/contacts":
        setViewTitle("Contactos");
        break;
      case "/dashboard":
        setViewTitle(null);
        break;
      case "/plantillas":
        setViewTitle(null);
        break;
      case INICIO_ROUTE:
        setViewTitle(null);
        break;
      case "/analytics":
        setViewTitle("");
        break;
      case "/analytics/agents":
        setViewTitle("");
        break;
      case "/help":
        setViewTitle("Lo nuevo de iVentas");
        break;
      default:
        break;
    }
  }, [location.pathname]);

  // Inicio: a user who receives tasks stays subscribed on every screen, so the
  // `taskOffered` toast reaches them wherever they are; /inicio itself also
  // subscribes for whoever can open it. Everybody else keeps the rule of
  // before (only the chat and the boards).
  const receivesTasks = receivesHumanTasks(user.data);
  const inicioAllowed = canSeeInicio(user.data);

  useEffect(() => {
    const shouldSubscribe =
      location.pathname.includes("/chat") ||
      location.pathname.includes("/board") ||
      (inicioAllowed && location.pathname.startsWith(INICIO_ROUTE)) ||
      receivesTasks;

    if (shouldSubscribe) {
      binder.subscribe();
    } else {
      binder.unsubscribe();
    }

    return () => binder.unsubscribe();
    // `handleNotification` NO va en las dependencias, a propósito: el cuerpo del
    // efecto no lo usa, y `useBinder` lo lee desde un ref, así que un callback
    // nuevo llega solo a los handlers ya atados sin tocar la suscripción.
    // Tenerlo aquí ataba la garantía de "no se resuscribe" a que sus propias
    // deps (`history`, `dispatch`) no cambiaran nunca — cierto hoy, pero por
    // accidente. Quitarlo la vuelve incondicional, que es lo que el spec dice.
  }, [
    location.pathname,
    user.data?.company?.id,
    user.data?.rol?.name,
    user.data?.id,
    binder,
    receivesTasks,
    inicioAllowed,
  ]);

  useEffect(() => {
    console.log('PATHNAME =>>>>>', location.pathname)

    dispatch(getLoginDataAction());

    window.addEventListener("offline", (e) => {
      console.log("you went offline");
      toast.dismiss();
      toast.warn("Revisa tu conexión a Internet", {
        position: "top-center",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });

    window.addEventListener("online", (e) => {
      console.log("you went online");
      toast.dismiss();
      toast.success("Conexión restablecida", {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });

    return () => {
      window.removeEventListener("online", () => {});
      window.removeEventListener("offline", () => {});
    };
  }, []);

  useEffect(() => {
    if (channels.reload) dispatch(getLoginDataAction());
  }, [channels.reload]);

  // Repara un snapshot de company degradado por un outage de billing (backend#244)
  // sin obligar a F5. Mientras `planName` esté ausente, re-checa cada 60s (alineado
  // al TTL degradado del backend) y también al volver el foco/visibilidad del tab
  // (análogo web a reabrir la app, y cubre el throttling de setInterval en tabs en
  // segundo plano). Todo se desmonta en cuanto la company se re-mezcla completa.
  const companyDegraded = isCompanyDegraded(user.data);
  useEffect(() => {
    if (!companyDegraded) return undefined;

    const RETRY_MS = 60000;
    const intervalId = setInterval(() => {
      dispatch(refreshDegradedCompanyAction());
    }, RETRY_MS);

    const refreshOnActive = () => {
      if (document.visibilityState === "visible") {
        dispatch(refreshDegradedCompanyAction());
      }
    };
    document.addEventListener("visibilitychange", refreshOnActive);
    window.addEventListener("focus", refreshOnActive);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", refreshOnActive);
      window.removeEventListener("focus", refreshOnActive);
    };
  }, [companyDegraded, dispatch]);

  useEffect(() => {
    const planStatus = user?.data?.company?.status;

    if (!planStatus) return;
    // Partner access: in a sede tab this is the status of the SEDE's company.
    // The partner cannot act on those screens, so the tab stays on the chat.
    if (isSedeMode()) return;

    if (
      (planStatus === PlanStatus.INACTIVE || planStatus === PlanStatus.PAUSED)
      && location.pathname !== CONSTANTS.UPDATE_SUBSCRIPTION_ROUTE
    ) {
      history.replace(CONSTANTS.UPDATE_SUBSCRIPTION_ROUTE);
    }

    if (
      planStatus === PlanStatus.AWAITING_FIRST_PAYMENT
      && location.pathname !== CONSTANTS.WA_VINCULATION_ROUTE
    ) {
      history.replace(CONSTANTS.FIRST_PAYMENT_ROUTE);
    }

    if (planStatus !== PlanStatus.AWAITING_FIRST_PAYMENT && location.pathname === CONSTANTS.FIRST_PAYMENT_ROUTE) {
      history.replace("/chat");
    }
  }, [user?.data?.company?.status, location.pathname]);

  const clearData = useCallback(() => {
    // Partner access: as a sede this ends the sede (reload into the normal
    // session); the normal session is never cleared from a sede tab.
    endSessionUnlessSede({
      history,
      dispatch,
      clearAction: clearDataAction,
      clearStorage: () => localStorage.clear(),
    });
  }, [history, dispatch]);

  // OJO: esto se evaluaba y EJECUTABA en el cuerpo del componente. El dispatch
  // de `clearData` en fase de render disparaba un re-render inmediato, y como
  // `localStorage.clear()` borra el token la condición se volvía verdadera para
  // siempre → "Too many re-renders" (DASHBOARD-ZC-HQ). Leer aquí es seguro;
  // el efecto lo hace el guard, una sola vez.
  const mustClearSession = shouldClearSession({
    user,
    validateAuth,
    hasToken: Boolean(localStorage.getItem("token")),
  });

  useSessionGuard({ shouldClear: mustClearSession, onClear: clearData });

  // El dashboard sólo se pinta cuando hay sesión viva y los datos ya cargaron.
  // Es la misma condición de los early returns de abajo, nombrada aquí para
  // poder usarla en un efecto (los hooks van antes de cualquier return).
  const dashboardVisible =
    !mustClearSession && Boolean(user?.data?.id) && !user.loadingData;

  // Pedir permiso de notificaciones era un efecto colateral en pleno render:
  // durante la tormenta de re-renders se llamaba una vez por render. Va en un
  // efecto, pero NO al montaje: en el montaje se pedía durante la carga e
  // incluso yendo camino del login. Se pide cuando el dashboard ya está a la
  // vista, que es donde estaba antes en el orden del render.
  useEffect(() => {
    if (!dashboardVisible) return;
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission().then((permission) => {
        console.log(permission);
      });
    }
  }, [dashboardVisible]);

  const notificationActions = {
    messageStatus: updateMessageStatus,
    newUserName: getClientNameFromNotification,
    tagsUpdate: updateClientTags,
    newClient: updateConverations,
    newMessage: updateConverations,
    groupAdmin: handleGroupAdmin,
    unassignClient: unassignClient,
    deleteConversation: deleteConversationAction,
    archived: archivedConversationAction,
    archivedBroadcastConversation: archivedBroadConversationAction,
    markAsRead: markAsReadAction,
    markAsUnread: markAsUnReadAction,
    conversationValuable: markAsConversationValuable,
    finishBotAssignment: finishBotAssignment,
    openClient: setConversationClosed,
    updateUserData: updateDatasheet,
    conversationVisibilityChanged: handleConversationVisibilityChanged,
    conversationSeated: conversationSeatedReceived,
    conversationUnseated: conversationUnseatedReceived,
    conversationLimitCapacity: capacityReceived,
    conversationQueueChanged: queueChangedReceived,
    conversationLimitAgentLoad: agentLoadReceived,
    ...humanTaskNotificationActions,
    onLinkedChannel: (data) => {
      console.log("onLinkedChannel => ", data);
      history.replace("/chat");
    },
  };

  const hasCircularReference = (obj) => {
    const seenObjects = new WeakSet();

    const detect = (obj) => {
      if (typeof obj !== "object" || obj === null) {
        return false;
      }

      if (seenObjects.has(obj)) {
        return true;
      }

      seenObjects.add(obj);

      for (let key in obj) {
        if (obj.hasOwnProperty(key) && detect(obj[key])) {
          return true;
        }
      }

      return false;
    };

    return detect(obj);
  };

  const replacer = (key, value) => {
    // Detectar referencias circulares y reemplazarlas
    if (key === "lastMessage" && typeof value === "object" && value !== null) {
      const cleanedClient = { ...value };

      cleanedClient.client = "[circular]";

      return cleanedClient;
    }
    return value;
  };

  const cleanCircularObjects = (inputData) => {
    if (hasCircularReference(inputData)) {
      console.log("hasCircularReference => ", inputData);
      let serializedData = JSON.stringify(inputData, replacer);
      return JSON.parse(serializedData);
    }
    // serializedData = cleanCircularObjects(serializedData);
    console.log("cleanCircularObjects => ", inputData);
    return inputData;
  };

  // Con la sesión caída no se pinta el dashboard: el guard ya está redirigiendo
  // al login. Antes se caía en el `<Loader />` de abajo por efecto secundario
  // (tras `clearData()` el usuario quedaba sin id); ahora es explícito.
  if (mustClearSession) {
    return <Loader />;
  }

  if (!user?.data?.id || user.loadingData) {
    return <Loader />;
  }

  return (
    <GridLayout>
      <Nav />
      {/* Sin condicionar por ruta: una caída del proveedor aplica en cualquier
          pantalla, y el componente ya se oculta solo si no hay incidencias. */}
      <IncidentBanner />
      {!isPaymentLocation && (
        <SuscriptionAlert />
      )}
      <Main>
        <SectionPage isChat={isChat || path.includes("/board")}>
          {(!isChat && !path.includes("/board")) &&
            viewTitle &&
            !path?.includes("/broadcast") &&
            !path?.includes("/contacts") &&
            !path?.includes("/users") &&
            !path?.includes("/album") && <Title>{viewTitle}</Title>}

          <PageContainer
            isChat={isChat || path.includes("/board")}
            isPageChat={path.includes("/chat") || path.includes("/board")}
            hideTitle={
              path?.includes("/broadcast") || path?.includes("/contacts")
              || path?.includes("/config") || path?.includes("/spaces")
              || path?.includes("/help") || path?.includes("/account")
              || path?.includes("/dashboard") || path?.includes("/plantillas") || path?.includes("/analytics")
              || path?.includes(INICIO_ROUTE)
              || path?.includes("/users") || path?.includes("/bot")
              || path?.includes("/multimedia") || path?.includes("/quickAnswers")
            }
            isCreateWhatsappTemplate={
              whatsappTemplateView === "createWhatsappTemplate" ||
              whatsappTemplateView === "whatsappTemplateCategory"
            }
          >
            <Route
              render={(componentProps) =>
                routeGuard(path, user) ? (
                  <Component {...componentProps} {...props} />
                ) : (
                  <Redirect to="/forbidden" />
                )
              }
            />
          </PageContainer>
        </SectionPage>
      </Main>
    </GridLayout>
  );
};

export default DashboardLayout;
